import { h, r as registerInstance, d as createEvent, c as getElement, F as Fragment } from './index-34617187.js';
import { P as WindowEventMap, i as isGridPopupInEscPath, l as createSelector, Q as eventPath, J as COPILOT_CANVAS_WRAPPER, K as AXF_HEADER_CONTAINER, C as BXF_FOCUS_KEYBOARD_ONLY } from './bxf-utils-3908c3c5.js';
import { B as BxfModalConstants, b as BxfOverlayCenter } from './bxf-modal.constants-83a74e7f.js';
import { K as KeyboardEventKey } from './keyboard-event-key.enum-2f6c4d91.js';
import { B as BxfButtonTypeEnum } from './button-type.enum-3452e5b6.js';
import { B as BxfButtonSizeEnum } from './button-size.enum-43a454f0.js';
import { map, isEmpty, filter, includes } from 'lodash-es';
import { B as BxfPositionConstants } from './focus-trap-023cd6d1.js';
import { B as BxfDefaultState } from './bxf-default-store-cc52e0b9.js';
import { i as isUsingI18n, B as BxfI18n, t as translateKeys } from './i18n.config-355137b0.js';
import { g as getParentOverlayContainer } from './get-parent-overlay-container-5aaa107a.js';
import 'dompurify';
import './query-selector-shadow-dom-dc946919.js';

const { BUTTONS, PRIMARY_BUTTON_PADDING, PRIMARY_BUTTON_PADDING_COMPACT, HEADER: HEADER$1, HEADER_COMPACT: HEADER_COMPACT$1, HEADER_TEXT: HEADER_TEXT$1, HEADER_TEXT_COMPACT: HEADER_TEXT_COMPACT$1, FOOTER, FOOTER_COMPACT, BXF_MODAL: BXF_MODAL$2, } = BxfModalConstants;
class BxfModalAction {
    delegate;
    constructor(delegate) {
        this.delegate = delegate;
    }
    removeEventListeners() {
        document.removeEventListener(WindowEventMap.keydown, this.escapeKeyHandler);
    }
    addEventListeners() {
        document.addEventListener(WindowEventMap.keydown, this.escapeKeyHandler);
    }
    escapeKeyHandler = (event) => {
        if (event.key === KeyboardEventKey.Escape) {
            const { modalElement, closeAllModalsOnEscape, isEscapeDisabled } = this.delegate;
            if (isEscapeDisabled)
                return;
            if (isGridPopupInEscPath(event))
                return;
            if (closeAllModalsOnEscape) {
                // Close all open modals
                this.delegate.close();
            }
            else {
                // Only close the top-most modal
                const modalList = document.body.getElementsByClassName(BXF_MODAL$2);
                const isTopmostModal = modalList[modalList.length - 1] === modalElement;
                if (isTopmostModal) {
                    this.delegate.close();
                }
            }
        }
    };
    getPrimaryButtonClass() {
        const paddingClass = `${PRIMARY_BUTTON_PADDING} ${this.delegate.isCompact ? PRIMARY_BUTTON_PADDING_COMPACT : ''}`;
        return this.delegate._hasSecondaryButton ||
            this.delegate.host.querySelector(`[slot='secondary-button']`)
            ? paddingClass
            : '';
    }
    renderFooter() {
        const footerClass = `${FOOTER} ${this.delegate.isCompact ? FOOTER_COMPACT : ''}`;
        const paddingClass = `${PRIMARY_BUTTON_PADDING} ${this.delegate.isCompact ? PRIMARY_BUTTON_PADDING_COMPACT : ''}`;
        if (!this.delegate.hasCustomFooter) {
            return (h("div", { class: footerClass },
                h("div", { class: BUTTONS },
                    h("div", { class: paddingClass },
                        h("bxf-button", { type: BxfButtonTypeEnum.PRIMARY, onClick: (event) => this.delegate.onPrimaryButtonClick(event), size: this.delegate.isCompact
                                ? BxfButtonSizeEnum.SMALL
                                : BxfButtonSizeEnum.REGULAR, label: this.delegate.primaryButtonLabel, keepMouseFocus: this.delegate.keepMouseFocus, dataTestSuffix: createSelector('00', this.delegate.dataTestSuffix, true) })),
                    h("bxf-button", { type: BxfButtonTypeEnum.SECONDARY, onClick: (event) => this.delegate.onSecondaryButtonClick(event), size: this.delegate.isCompact
                            ? BxfButtonSizeEnum.SMALL
                            : BxfButtonSizeEnum.REGULAR, label: this.delegate.secondaryButtonLabel, keepMouseFocus: this.delegate.keepMouseFocus, dataTestSuffix: createSelector('01', this.delegate.dataTestSuffix, true) }))));
        }
        // Use slots when hasCustomFooter is true
        return (h("div", { class: footerClass },
            h("div", null,
                h("slot", { name: 'tertiary-button' })),
            h("div", { class: BUTTONS },
                h("div", { class: this.getPrimaryButtonClass() },
                    h("slot", { name: 'primary-button' })),
                h("slot", { name: 'secondary-button' }))));
    }
    renderHeader() {
        const CustomHeading = `h${this.delegate.headingLevel}`;
        const headingClass = `${HEADER$1} ${this.delegate.isCompact ? HEADER_COMPACT$1 : ''}`;
        const headingTextClass = `${HEADER_TEXT$1} ${this.delegate.isCompact ? HEADER_TEXT_COMPACT$1 : ''}`;
        return (h("div", { class: headingClass },
            h(CustomHeading, { class: headingTextClass }, this.delegate.header)));
    }
}

const { BXF_MODAL: BXF_MODAL$1, CLASSNAME, WRAPPER: WRAPPER$1, HEADER, HEADER_COMPACT, HEADER_CLOSE_ICON, HEADER_TEXT, HEADER_TEXT_COMPACT, } = BxfModalConstants;
class BxfModalInformation {
    delegate;
    _clickOutsideStarted = false;
    constructor(delegate) {
        this.delegate = delegate;
    }
    removeEventListeners() {
        document.removeEventListener(WindowEventMap.mousedown, this.mouseDownOutside);
        document.removeEventListener(WindowEventMap.mouseup, this.mouseUpOutside);
        document.removeEventListener(WindowEventMap.keydown, this.escapeKeyHandler);
    }
    addEventListeners() {
        document.addEventListener(WindowEventMap.mousedown, this.mouseDownOutside);
        document.addEventListener(WindowEventMap.mouseup, this.mouseUpOutside);
        document.addEventListener(WindowEventMap.keydown, this.escapeKeyHandler);
    }
    escapeKeyHandler = (event) => {
        if (event.key === KeyboardEventKey.Escape) {
            const { modalElement, closeAllModalsOnEscape, isEscapeDisabled } = this.delegate;
            if (isEscapeDisabled || isGridPopupInEscPath(event))
                return;
            if (closeAllModalsOnEscape) {
                // Close all open modals
                this.delegate.close();
            }
            else {
                // Only close the top-most modal
                const modalList = document.body.getElementsByClassName(BXF_MODAL$1);
                const isTopmostModal = modalList[modalList.length - 1] === modalElement;
                if (isTopmostModal) {
                    this.delegate.close();
                }
            }
        }
    };
    mouseDownOutside = (event) => {
        this._clickOutsideStarted = this.isOutsideModal(event);
    };
    mouseUpOutside = (event) => {
        if (this._clickOutsideStarted && this.isOutsideModal(event)) {
            this._clickOutsideStarted = false;
            this.delegate.close();
        }
    };
    isOutsideModal(event) {
        const { MENU_CONTAINER, DROPDOWN_CONTAINER, GRID_POPUP } = BxfPositionConstants.STRING;
        const classMap = map(eventPath(event), CLASSNAME);
        const dropdownController = isEmpty(filter(classMap, (value) => includes(value, DROPDOWN_CONTAINER)));
        const menuController = isEmpty(filter(classMap, (value) => includes(value, MENU_CONTAINER)));
        const modalController = isEmpty(filter(classMap, (value) => includes(value, WRAPPER$1)));
        const gridPopup = isEmpty(filter(classMap, (value) => includes(value, GRID_POPUP)));
        const copilotPanel = isEmpty(filter(classMap, (value) => includes(value, COPILOT_CANVAS_WRAPPER)));
        const axfHeader = isEmpty(filter(classMap, (value) => includes(value, AXF_HEADER_CONTAINER)));
        return (dropdownController &&
            menuController &&
            modalController &&
            gridPopup &&
            copilotPanel &&
            axfHeader);
    }
    closeButtonClasses() {
        return `${HEADER_CLOSE_ICON} ${this.delegate.keepMouseFocus ? '' : BXF_FOCUS_KEYBOARD_ONLY}`;
    }
    renderHeader() {
        /**
         * Set custom HTML heading tag
         * https://dev.to/s_aitchison/psa-stop-hard-coding-heading-levels-in-your-react-components-2ekp
         */
        const CustomHeading = `h${this.delegate.headingLevel}`;
        const headerClass = `${HEADER} ${this.delegate.isCompact ? HEADER_COMPACT : ''}`;
        const headingTextClass = `${HEADER_TEXT} ${this.delegate.isCompact ? HEADER_TEXT_COMPACT : ''}`;
        return (h("div", { class: headerClass },
            h(CustomHeading, { class: headingTextClass }, this.delegate.header),
            h("button", { class: this.closeButtonClasses(), onClick: () => this.delegate.close(), "aria-label": this.delegate.closeButtonLabel },
                h("bxf-icon", { type: 'delete', state: 'primary', dataTestSuffix: this.delegate.dataTestSuffix }))));
    }
    renderFooter() {
        return null;
    }
}

const bxfModalCss = "button.sc-bxf-modal:hover,a.sc-bxf-modal:hover,input[type=radio].sc-bxf-modal:hover,input[type=checkbox].sc-bxf-modal:hover,input[type=radio].sc-bxf-modal:checked:hover,input[type=checkbox].sc-bxf-modal:checked:hover,svg.sc-bxf-modal:hover{cursor:pointer}svg[disabled].sc-bxf-modal:hover,button[disabled].sc-bxf-modal:hover,label[disabled].sc-bxf-modal:hover,input[type=checkbox].sc-bxf-modal:disabled:hover,input[type=radio].sc-bxf-modal:disabled:hover,input[type=checkbox].sc-bxf-modal:checked:disabled:hover,input[type=radio].sc-bxf-modal:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-modal{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-modal__wrapper.sc-bxf-modal,.bxf-modal__wrapper--no-border.sc-bxf-modal{border-radius:0.25rem;border:1px solid var(--dialog__border-color);border-top-width:0.25rem;border-top-color:var(--dialog__top-border-color--prompt);background-color:var(--widget__background-color);min-height:25vh;max-height:94vh;display:flex;flex-direction:column}.bxf-modal__wrapper--no-border.sc-bxf-modal{border-top:none;border-radius:0}.bxf-modal__container.sc-bxf-modal,.bxf-modal__container--action.sc-bxf-modal,.bxf-modal__container--information.sc-bxf-modal{display:flex;flex-direction:column;flex:1 1 auto;height:100%;min-height:0}.bxf-modal__container--large.sc-bxf-modal{padding:0;max-height:65vh;overflow:hidden}.bxf-modal__container--action.sc-bxf-modal{border-bottom:1px solid var(--dialog__border-color--partition)}.bxf-modal__header.sc-bxf-modal{padding:1.25rem 2rem 1.1875rem;border-bottom:1px solid var(--dialog__border-color--partition);color:var(--primary-text__color);line-height:1.2;display:inline-flex;justify-content:space-between}.bxf-modal__header--compact.sc-bxf-modal{padding:0.5rem 1rem;border-bottom:1px solid var(--dialog__border-color--partition);color:var(--primary-text__color);line-height:1.2;display:inline-flex;justify-content:space-between}.bxf-modal__header-close-icon.sc-bxf-modal{align-self:center;padding:0 0 0 1rem;border:0;margin:0;background:transparent}.bxf-modal__header-close-icon.sc-bxf-modal:focus{outline:0}.bxf-modal__header-close-icon.sc-bxf-modal:focus bxf-icon.sc-bxf-modal{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-modal__header-close-icon.sc-bxf-modal:focus.bxf__focus--keyboard-only:not(:focus-visible) bxf-icon.sc-bxf-modal{outline:0}.bxf-modal__header-text.sc-bxf-modal{font-size:1.25rem;font-weight:var(--font-weight-bold);margin:0}.bxf-modal__header-text--compact.sc-bxf-modal{font-size:1rem}.bxf-modal__content.sc-bxf-modal{font-size:0.8125rem;line-height:1.5384615385;color:var(--primary-text__color);max-height:77vh;overflow-y:auto;overflow-x:auto;display:flex;flex:auto}.bxf-modal__content--padding.sc-bxf-modal{padding:1.5rem 2rem 2rem}.bxf-modal__content--large.sc-bxf-modal{max-width:90vw;padding:0}.bxf-modal__content--grey.sc-bxf-modal{background-color:var(--modal__background-color--grey)}.bxf-modal__footer.sc-bxf-modal{display:flex;justify-content:flex-end;font-size:0.8125rem;line-height:1.5384615385;padding:1rem;align-items:center}.bxf-modal__footer--compact.sc-bxf-modal{display:flex;justify-content:flex-end;font-size:0.8125rem;line-height:1.5384615385;padding:0.5rem 1rem;align-items:center}.bxf-modal__buttons.sc-bxf-modal{display:inline-flex}.bxf-modal__primary-button--padding.sc-bxf-modal{padding:0 1rem}.bxf-modal__primary-button-padding--compact.sc-bxf-modal{padding:0 0.5rem}.bxf-modal__footer.sc-bxf-modal bxf-link.sc-bxf-modal{padding-right:1rem}.bxf-modal__footer-buttons.sc-bxf-modal{display:flex;justify-content:flex-end;gap:0.75rem;align-items:center;padding:0.75rem 1rem}.bxf-modal.sc-bxf-modal{max-height:95vh;pointer-events:auto;position:static;overflow-y:hidden;overflow-x:hidden;min-height:25vh;display:flex;box-shadow:0 0.25rem 0.75rem 0 var(--dialog__box-shadow-color);margin:0 2rem}.bxf-modal.sc-bxf-modal:focus{outline:0}.bxf-modal__close-button.sc-bxf-modal{border:0;background-color:transparent;padding:0;margin:0}.bxf-modal__close-button.sc-bxf-modal:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-modal__close-button.bxf__focus--keyboard-only.sc-bxf-modal:focus:not(:focus-visible){outline:0}";
const BxfModalStyle0 = bxfModalCss;

const { CONTAINER_STICKY, CONTENT_HIDE, INFORMATION, BXF_MODAL, CONTAINER_ACTION, CONTAINER_INFORMATION, ACTION, CONTAINER_LARGE, WRAPPER, WRAPPER_NO_BORDER, CONTENT_LARGE, CONTENT, CONTENT_GREY, CONTENT_PADDING, SUBMIT, CANCEL, CUSTOM_FOOTER_BUTTON, PRIMARY_BUTTON, SECONDARY_BUTTON, TERTIARY_BUTTON, CUSTOM_FOOTER, CUSTOM_FOOTER_SLOT, PRIMARY_BUTTON_SLOT, SECONDARY_BUTTON_SLOT, TERTIARY_BUTTON_SLOT, } = BxfModalConstants;
const BxfModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.modalOpened = createEvent(this, "modalOpened", 7);
        this.modalClosed = createEvent(this, "modalClosed", 7);
        this.primaryButtonClicked = createEvent(this, "primaryButtonClicked", 7);
        this.secondaryButtonClicked = createEvent(this, "secondaryButtonClicked", 7);
        this.header = 'Warning';
        this.headingLevel = 2;
        this.type = 'information';
        this.isLarge = false;
        this.isCompact = BxfDefaultState.isCompact;
        this.hasGreyContentArea = false;
        this.hasCustomHeader = false;
        this.hasCustomFooter = false;
        this.hasContentPadding = false;
        this.customOverlayZIndex = undefined;
        this.isOpen = false;
        this.primaryButtonLabel = SUBMIT;
        this.secondaryButtonLabel = CANCEL;
        this.isEscapeDisabled = false;
        this.closeAllModalsOnEscape = true;
        this.isTracking = true;
        this.trackingData = undefined;
        this.hasTopBorder = true;
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.eventData = {};
        this.keepMouseFocus = false;
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
    }
    modalElement;
    _hasSecondaryButton = false;
    closeButtonLabel = BxfModalConstants.CLOSE_BUTTON_LABEL;
    _componentType;
    _overlayCenter;
    _modalOpenedEmitted = false;
    i18n;
    get host() { return getElement(this); }
    /**
     * This event emits when modal is opened.
     */
    modalOpened;
    /**
     * This event emits when modal is closed.
     */
    modalClosed;
    /**
     * An event that is emitted when the primary button is clicked
     */
    primaryButtonClicked;
    /**
     * An event that is emitted when the secondary button is clicked
     */
    secondaryButtonClicked;
    /**
     * This method allows for the opening of modal
     */
    async open() {
        this.isOpen = true;
    }
    /**
     * This method allows for the closing of modal
     */
    async close() {
        this.closeModal();
    }
    /**
     * Watch on the customOverlayZIndex
     * @param {number} newProp
     */
    customOverlayZIndexHandler(newProp, oldProp) {
        if (newProp <= 0) {
            console.warn(`customOverlayZIndex must be a positive number. Using previous value of ${oldProp}.`);
            this.customOverlayZIndex = oldProp;
        }
        else if (newProp && newProp !== oldProp && this._overlayCenter) {
            this._overlayCenter.setCustomZIndex(newProp);
        }
    }
    frameContentResizeHandler(event) {
        const { width } = event.detail;
        if (width) {
            this._overlayCenter?.setWidth(`${width}px`);
        }
    }
    _frameMainContent;
    componentWillLoad() {
        if (this.customOverlayZIndex <= 0) {
            console.warn('customOverlayZIndex must be a positive number. Setting it undefined by default.');
            this.customOverlayZIndex = undefined;
        }
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        this.renderType();
        this.host.classList.add(CONTENT_HIDE);
        this._frameMainContent = document.querySelector(`.${CONTAINER_STICKY}`);
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
    }
    componentDidRender() {
        if (this.isOpen) {
            this.initOverlay();
            this.openModal();
        }
        else {
            this.closeModal();
        }
    }
    componentDidLoad() {
        this.openModal();
    }
    disconnectedCallback() {
        this.closeModal();
        this.i18n?.destroyTranslations();
    }
    renderType() {
        switch (this.type) {
            case ACTION:
                this._componentType = new BxfModalAction(this);
                break;
            case INFORMATION:
            default:
                this._componentType = new BxfModalInformation(this);
                break;
        }
    }
    initOverlay() {
        /* istanbul ignore else */
        if (!this._overlayCenter && this.modalElement) {
            this._overlayCenter = new BxfOverlayCenter(getParentOverlayContainer(this.parentOverlayContainerSelector));
        }
    }
    onPrimaryButtonClick(event) {
        this.primaryButtonClicked.emit({
            srcEvent: event,
            eventData: this.eventData,
        });
        this.closeModal();
    }
    onSecondaryButtonClick(event) {
        this.secondaryButtonClicked.emit({
            srcEvent: event,
            eventData: this.eventData,
        });
        this.closeModal();
    }
    /**
     * Add modal element, removed by overlay, back to host element
     */
    addModalElemToHost() {
        this.host.appendChild(this.modalElement);
    }
    closeModal() {
        this.isOpen = false;
        this._modalOpenedEmitted = false;
        /* istanbul ignore else */
        if (this._overlayCenter) {
            this._overlayCenter.close(this.modalElement);
            this._overlayCenter = null;
        }
        /* istanbul ignore else */
        if (this.modalElement) {
            this.addModalElemToHost();
            this.modalElement = null;
            this._componentType.removeEventListeners();
            this.modalClosed.emit({ eventData: this.eventData });
        }
    }
    openModal() {
        if (this.isOpen && !this._modalOpenedEmitted && this.modalElement) {
            /* istanbul ignore else */
            if (!this._hasSecondaryButton) {
                this._hasSecondaryButton = !!this.modalElement.querySelector(`[slot='secondary-button']`);
            }
            const overlayModalElement = this.modalElement;
            overlayModalElement.classList.add(BXF_MODAL);
            this._overlayCenter.setInitiallyFocusedElem();
            this._overlayCenter.open(overlayModalElement);
            /**
             * setting the width of the modal overlay to be the current width of the frame's main
             *  content in case copilot is already open before the modal is opened
             */
            if (this._frameMainContent) {
                const frameMainContentWidth = this._frameMainContent.getBoundingClientRect().width;
                this._overlayCenter.setWidth(`${frameMainContentWidth}px`);
            }
            this._overlayCenter.setCustomZIndex(this.customOverlayZIndex);
            this._componentType.addEventListeners();
            this.modalOpened.emit({ eventData: this.eventData });
            this._modalOpenedEmitted = true;
        }
    }
    handleModalRef(el) {
        /* istanbul ignore else */
        if (el && this.isOpen) {
            this.modalElement = el;
        }
    }
    get containerClasses() {
        return `${this.type === ACTION ? CONTAINER_ACTION : CONTAINER_INFORMATION} ${this.isLarge ? CONTAINER_LARGE : ''}`.trim();
    }
    get contentClasses() {
        const contentClassList = [CONTENT];
        this.hasContentPadding && contentClassList.push(CONTENT_PADDING);
        this.isLarge && contentClassList.push(CONTENT_LARGE);
        this.hasGreyContentArea && contentClassList.push(CONTENT_GREY);
        return contentClassList.join(' ');
    }
    getCustomSlot(slotName) {
        return this.modalElement?.querySelector(slotName);
    }
    removeHiddenAttributeInSlot(slotName) {
        const customSlot = this.getCustomSlot(slotName);
        if (this.modalElement &&
            customSlot &&
            getComputedStyle(customSlot).display === 'none') {
            customSlot.removeAttribute('hidden');
            customSlot.classList.remove(CONTENT_HIDE);
        }
    }
    addHiddenAttributeInSlot(slotName) {
        const customSlot = this.getCustomSlot(slotName);
        if (this.modalElement &&
            customSlot &&
            getComputedStyle(customSlot).display !== 'none') {
            customSlot.classList.add(CONTENT_HIDE);
        }
    }
    renderHeader() {
        /* istanbul ignore else */
        const customHeaderSlot = "[slot='custom-header']";
        if (this.hasCustomHeader) {
            this.removeHiddenAttributeInSlot(customHeaderSlot);
            return h("slot", { name: 'custom-header' });
        }
        this.addHiddenAttributeInSlot(customHeaderSlot);
        return this._componentType.renderHeader();
    }
    renderFooter() {
        /* istanbul ignore else */
        if (this.hasCustomFooter) {
            this.removeHiddenAttributeInSlot(CUSTOM_FOOTER_SLOT);
            this.removeHiddenAttributeInSlot(PRIMARY_BUTTON_SLOT);
            this.removeHiddenAttributeInSlot(SECONDARY_BUTTON_SLOT);
            this.removeHiddenAttributeInSlot(TERTIARY_BUTTON_SLOT);
            const hasPrimaryButton = !!this.host.querySelector(PRIMARY_BUTTON_SLOT);
            const hasSecondaryButton = !!this.host.querySelector(SECONDARY_BUTTON_SLOT);
            const hasTertiaryButton = !!this.host.querySelector(TERTIARY_BUTTON_SLOT);
            return (h(Fragment, null, h("slot", { name: CUSTOM_FOOTER }), (hasPrimaryButton ||
                hasSecondaryButton ||
                hasTertiaryButton) && (h("div", { class: CUSTOM_FOOTER_BUTTON }, h("slot", { name: TERTIARY_BUTTON }), h("slot", { name: PRIMARY_BUTTON }), h("slot", { name: SECONDARY_BUTTON })))));
        }
        this.addHiddenAttributeInSlot(CUSTOM_FOOTER_SLOT);
        this.addHiddenAttributeInSlot(PRIMARY_BUTTON_SLOT);
        this.addHiddenAttributeInSlot(SECONDARY_BUTTON_SLOT);
        this.addHiddenAttributeInSlot(TERTIARY_BUTTON_SLOT);
        return this._componentType.renderFooter();
    }
    renderModalContainer() {
        return (h("div", { class: this.hasTopBorder ? WRAPPER : WRAPPER_NO_BORDER }, h("div", { class: this.containerClasses }, this.renderHeader(), h("div", { class: this.contentClasses }, h("slot", { name: 'content' }))), this.renderFooter()));
    }
    render() {
        return (h("div", { key: '60aca22da63601592dd12dc5fc9694aa8a539708', ref: (el) => this.handleModalRef(el), style: {
                display: `${this.isOpen} ? 'block' : 'none'`,
            }, role: 'dialog', "aria-label": this.header, "aria-modal": 'true', "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, this.renderModalContainer()));
    }
    static get watchers() { return {
        "customOverlayZIndex": ["customOverlayZIndexHandler"]
    }; }
};
BxfModal.style = BxfModalStyle0;

export { BxfModal as bxf_modal };
